import React from 'react';
import Calendar from '@toast-ui/react-calendar';
import { CUSTOM_THEME } from '../../../styles/styles';
import '../../../styles/tuiCalendarStyles.scss'
import { buildShiftTooltip, buildPaycodeTooltip } from '../../../App/EmployeeDashboard/Utils/uiGenerators';
import $ from 'jquery';
import { renderToStaticMarkup } from 'react-dom/server';
import { formatAs, DateFnsFormats } from '../../../../common-client2/src/services/ukgDateTime';
import { getFormattedPaycodeDuration} from '../../../App/EmployeeDashboard/Calendar/calendarFunctions'

const renderSchedule = (schedule) => {
    switch (schedule.calendarId) {
        case '0':
            // Own schedule
            return '<div class="shift">' + schedule.title + ' <span class="tooltiptext">' + renderToStaticMarkup(buildShiftTooltip(schedule.raw)) + '</span></div>'
        case '1':
            // Offered
            return '<div class="shift" style="color:' + schedule.color + ';">' + schedule.title + ' <span class="tooltiptext">' + renderToStaticMarkup(buildShiftTooltip(schedule.raw)) + '</span></div>'
        case '2':
            const paycode = schedule.raw;
            const toSecond = 60;
            const formattedDuration = getFormattedPaycodeDuration(paycode.durationInTime * toSecond);
            const title = `${paycode.payCodeRef.qualifier} [${formattedDuration}]`;
            paycode.startDateTime = paycode.startDate;
            paycode.endDateTime = paycode.endDate;
            
            return renderToStaticMarkup(
                <>
                    <div className="calendar-schedule--card-wrapper default-cursor">
                        <div className="schedule-card-title">{title}</div>
                    </div>
                    <span className="tooltiptext tooltiptext-top">
                        <span className="tooltip-arrow tooltip-bottom-arrow"></span>
                        {buildPaycodeTooltip(paycode, formattedDuration)}
                    </span>
                </>);
        default:
            return schedule.title
    }
}
class EmployeeSchedule extends React.Component {
    calendarRef = React.createRef();
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    generateCalendar = (firstDayOfTheWeek = 0) => {
        let { weeksCount = 1 } = this.props;
        if (this.calendarRef.current) {
            let calendarRef = this.calendarRef.current.getInstance();
            calendarRef.off('clickSchedule');
        }
        let height = (150 * weeksCount).toString() + "px"
        var calendar = <Calendar
            ref={this.calendarRef}
            height={height}
            view='month'
            calendars={[
                {
                    id: '0',
                    name: 'My Shifts',
                    bgColor: '#0A54A2',
                    borderColor: '#0A54A2',
                },
                {
                    id: '1',
                    name: 'My offers',
                    bgColor: '#00a9ff',
                    borderColor: '#00a9ff',
                },
            ]}
            theme={CUSTOM_THEME}
            schedules={this.props.schedule}
            disableDblClick={true}
            disableClick={true}
            isReadOnly={true}
            month={{
                visibleWeeksCount: weeksCount
            }}
            week={{
                startDayOfWeek: firstDayOfTheWeek
            }}
            taskView={false}
            scheduleView
            usageStatistics={false}
            onAfterRenderSchedule={this.unbindTitles}
            template={{
                time: function (schedule) {
                    return renderSchedule(schedule);
                },
                allday(schedule) {
                    return renderSchedule(schedule);
                },
            }}
        />;

        return calendar;
    }

    unbindTitles = () => {
        $('.tui-full-calendar-weekday-schedule-title').removeAttr('title');
        let tooltips = $('.tooltiptext')
        tooltips.each((index, value) => {
            let tooltip = $(value)[0];
            let tipX = 0;
            let tooltip_rect = tooltip.getBoundingClientRect();
            let wrapper = $(tooltip).parents('.more-detail')[0];
            if ((tooltip_rect.x + tooltip_rect.width) > $(wrapper).width()) // Out on the right
                tipX = -30;
            $(tooltip).css({ left: tipX })
        })

        // TEMPORARY: TUI calendar is planned to be removed; remove this block along with it.
        // The tooltip is rendered inside MUI DataGrid cells which clip overflow
        // (cell/row/main use overflow:hidden and contain). Move the tooltip to body
        // on hover so it escapes all clipping ancestors.
        $('body > .tooltiptext-portal').remove();
        $('.manager-dashboard .tui-full-calendar-weekday-schedule-title').each((_, el) => {
            const $title = $(el);
            if ($title.data('tooltipPortalBound')) return;
            if (!$title.find('.tooltiptext').length) return;
            $title.data('tooltipPortalBound', true);

            $title.on('mouseenter.tooltipPortal', () => {
                const $orig = $title.find('.tooltiptext').first();
                if (!$orig.length) return;
                $('body > .tooltiptext-portal').remove();


                $orig.addClass('tooltiptext-hidden');
                const $portal = $orig.clone()
                    .removeClass('tooltiptext-hidden')
                    .addClass('tooltiptext-portal')
                    .css({ top: '-9999px', left: '-9999px' });
                $portal.appendTo(document.body);

                const titleRect = el.getBoundingClientRect();
                const portalRect = $portal[0].getBoundingClientRect();
                let top = titleRect.top - portalRect.height;
                let left = titleRect.left;
                if (top < 5) top = titleRect.bottom;
                if (left + portalRect.width > window.innerWidth - 5) {
                    left = window.innerWidth - portalRect.width - 5;
                }
                if (left < 5) left = 5;
                $portal.css({ top, left });
            });

            $title.on('mouseleave.tooltipPortal', () => {
                $('body > .tooltiptext-portal').remove();
                $title.find('.tooltiptext').removeClass('tooltiptext-hidden');
            });
        });
    }

    componentDidMount = () => {
        let calendarRef = this.calendarRef.current.getInstance();
        calendarRef.setDate(formatAs(this.props.shiftDate, DateFnsFormats.YMD))
        calendarRef.render();
    }

    componentWillUnmount = () => {
        $('body > .tooltiptext-portal').remove();
    }

    render() {
        let calendar = this.generateCalendar(0);
        return (
            <React.Fragment>
                {calendar}
            </React.Fragment>
        )
    }
}

export default EmployeeSchedule;